import "./campaign-unavailable.css";

type CampaignUnavailableProps = {
  body: string;
  language: "ru" | "uz";
  onLanguage: () => void;
  title: string;
};

export function CampaignUnavailable({ body, language, onLanguage, title }: CampaignUnavailableProps) {
  return (
    <main className="campaign-unavailable" role="status" aria-live="polite">
      <div className="campaign-unavailable__content">
        <div className="campaign-unavailable__brand">ГОНКА STING</div>
        <h1 className="campaign-unavailable__title">{title}</h1>
        <p className="campaign-unavailable__body">{body}</p>
        <button data-ui-action="campaign_unavailable:language" className="campaign-unavailable__language" type="button" onClick={onLanguage}>
          {language === "ru" ? "Oʼzbekcha" : "Русский"}
        </button>
      </div>
    </main>
  );
}
